import React, { useRef, useEffect } from 'react';
import Cookies, { remove } from 'js-cookie';
import API_PATH from "../../constants/config.json";
import { CircularProgress } from '@material-ui/core';
import FileDownloading from '../Errors/FileDownloading';
const axios = require('axios');
const API_URL = process.env.REACT_APP_BASE_URL;
const AWS = require('aws-sdk'); 

const PublicFilesCard = props => {

    const [fileListStation, setFileListStation] = React.useState([]);
    const [getLoader, setLoaderDisable] = React.useState(false);
    const [errorDialogue, setErrorDialogue] = React.useState(false);
    const [fileToDownload, setFileToDownload] = React.useState([]);


    useEffect(() => {
        getFileList();
    }, []);

    const getFileList = (page = 1) => { // API call to get all files
        setLoaderDisable(true);
        try {
          axios({
            method: 'post',
            data: {
              stationId: props.stationData.station_id,
              pageNo: page,
              entriesPerPage: 10
            },
            headers: {
              'payload': Cookies.get('payload'),
              'agencyid': sessionStorage.getItem('agency_id')
            },
            url: API_URL + API_PATH.publicFileList,
          })
            .then(async function (response) {
              if (response.status && response.status == '200') {
                setLoaderDisable(false);
                setFileListStation(response.data.data.rows);
              } else {
                setFileListStation([]);
                setLoaderDisable(false);
              }
            })
            .catch(function (error) {
              if (error.response) {
                if (error.response.data.status == 403) {
                  setLoaderDisable(false);
                  setFileListStation([]);
                } else {
                  setFileListStation([]);
                  setLoaderDisable(false);
                }
              } else {
                setFileListStation([]);
                setLoaderDisable(false);
              }
            })
        } catch (error) {
          console.error(error);
          setLoaderDisable(false);
        }
    }

    const downloadFile = (file_id, bucketName, filename, originalFileName) => {
        setFileToDownload([...fileToDownload, file_id]);
        bucketName = bucketName + "-pub";
        let region = 'us-west-2';
        let config = {
          headers: {'Access-Control-Allow-Origin': '*'},
          withCredentials: false,
          responseType: 'blob'
        };
        axios.get(`https://${bucketName}.s3-${region}.amazonaws.com/${filename}`, config)
          .then(response => {
            if(response.status === 200 ){
              let blob = response.data;
              let link = document.createElement("a");
              link.href = window.URL.createObjectURL(blob);
              link.download = originalFileName;
              link.click();
            } else {
              handleOpenDialogueBox();
            }
            removeFromArray();
          }, error => {
            handleOpenDialogueBox();
            removeFromArray();
          });
    };

    const removeFromArray = (file_id) => {
        let tmp = [...fileToDownload];
        let pos = tmp.indexOf(file_id);
        if(pos >= 0)
            tmp.splice(pos, 1);
        setFileToDownload(tmp);
    }

    const handleOpenDialogueBox = () => {
        setErrorDialogue(true);
    }

    const handleCloseDialogueBox = () => {
        setErrorDialogue(false);
    }

    return (
        fileListStation.length > 0 &&
        <>    
            <label className='info-sub-title'>Files</label> 
            <ul className="public-files-list">
                {
                    fileListStation.map( file => (
                        <li>
                            <div>
                                <img src={require('../../assets/icons/attatchment.svg')} />
                                <label title={file.origin_name}>{file.origin_name.length > 34 ? file.origin_name.substring(0, 33)+'...' : file.origin_name}</label>
                                {
                                    fileToDownload.indexOf(file.file_id) >= 0 &&
                                    <div className={'download-loader'}></div>
                                }
                            </div>
                            <label onClick={() => downloadFile(file.file_id, file.bucket_name, file.base_name, file.origin_name)}>Download</label>
                        </li>
                    ))
                }
            </ul>
            <FileDownloading 
                errorDialogue={errorDialogue}
                handleCloseDialogueBox={handleCloseDialogueBox}
            />
        </>
      )
}
export default PublicFilesCard;